import { render, staticRenderFns } from "./NewDetail.vue?vue&type=template&id=660aab28&scoped=true&"
import script from "./NewDetail.vue?vue&type=script&lang=js&"
export * from "./NewDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewDetail.vue?vue&type=style&index=0&id=660aab28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660aab28",
  null
  
)

export default component.exports